export default __webpack_public_path__ + "static/media/Stone-1.2b5f23cc.gif";